import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useFormik } from "formik";

import * as Yup from "yup";
import { useQuery } from "react-query";
import { ICreateAndUpdateCompany } from "../../../../types/company.interface";
import Context from "../../../../context";
import { City, IItem, ILocation } from "../../../../types/common.interface";
import values from "../../../../values";
import validations from "../../../../validations";
import utils from "../../../../utils";
import {
  CustomButton2,
  CustomIcon,
  CustomInput,
  CustomLeafLet,
  CustomModal,
  CustomView,
  ImageUploader,
} from "../../../../components";
import TitleLine from "../../../../components/TitleLine";
import CustomDropDownSearch from "../../../../components/CustomDropDownSearch";
import "./index.scss";
import api from "../../../../api";
import { ICreateAndUpdateMunicipality } from "../../../../types/municipality.interface";
import { ICreateAndUpdateWorkTime } from "../../../../types/workTime.interface";
import { IProvinceCity } from "../../../../types/area.interface";

const CompanyDriverInformation = () => {
  const { showModal, loading, setShowModal, createCompany, selectedCompany } =
    React.useContext(Context?.CompanyScreen);

  const [selectedCities, setSelectedCities] = useState<City[]>([
    values?.constants?.hardCodeCity,
  ]);
  const [selectedLocation, setSelectedLocation] = useState<ILocation>();
  const [selectedImage, setSelectedImage] = useState<any>();
  const [selectedMunicipality, setSelectedMunicipality] =
    useState<ICreateAndUpdateMunicipality>();
  const [selectedWorkTimes, setSelectedWorkTimes] = useState<
    ICreateAndUpdateWorkTime[]
  >([]);
  const [errors, setErrors] = React.useState<any>({});
  const [selectedProvince, setSelectedProvince] = useState<IProvinceCity>();
  const [selectedCity, setSelectedCity] = useState<IProvinceCity>();

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------

  const municipalities = useQuery(
    [values?.useQueryKeys?.getAllMunicipality],
    () => api?.postMethod?.administrator?.getAllMunicipality({})
  );
  const resultWorkTimes = useQuery([values?.useQueryKeys?.getAllWorkTime], () =>
    api?.getMethod.company.findWorkTime({})
  );

  const workTimes = resultWorkTimes?.data?.result;

  const workTimesWithCompleteTitle =
    utils.workTimeWithCompeleteTitle(workTimes);

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  const formik = useFormik<ICreateAndUpdateCompany>({
    enableReinitialize: true,
    initialValues: {
      phoneNumber: "",
      name: "",
      firstName: "",
      lastName: "",
      address: "",
      userName: "",
      password: "",
      rePassword: "",
    },
    validationSchema: Yup.object({
      name: validations?.yupValidations?.companyName,
      address: validations.yupValidations.address,
      lastName: validations.yupValidations.lastName,
      firstName: validations.yupValidations.firstName,
      phoneNumber: validations.yupValidations.phoneNumber,
      userName: validations.yupValidations.userName,
      password: Yup.string().required("فیلد گذرواژه اجباری است"),
    }),
    onSubmit: (values: ICreateAndUpdateCompany, { setSubmitting }) => {
      const formValues: ICreateAndUpdateCompany = {
        _id: selectedCompany?._id,
        // cities: selectedCities?.map((item) => item?._id) as string[],
        workTimes: selectedWorkTimes?.map((item) => item?._id) as string[],
        municipality: selectedMunicipality?._id,
        lat: selectedLocation?.lat as string,
        lng: selectedLocation?.lng as string,
        logo: selectedImage?.link,
        // province: selectedProvince?._id,
        city: selectedCity?._id,

        ...values,
      };

      createCompany!(formValues);
    },
  });

  const submitHandler = () => {
    if (formik.values.password === formik.values.rePassword) {
      setErrors({ rePassword: "" });
      formik.submitForm();
    } else {
      setErrors({ rePassword: "تکرار گذرواژه اشتباه است" });
    }
  };

  async function onUploadImage(imageFile: File) {
    const imagePromise = await api.postMethod.common.uploadImage!(imageFile);
    if (imagePromise?.CODE === 2010) setSelectedImage(imagePromise?.result);
  }

  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.getMethod.common.findProvinceCity({})
  );

  const getAllCity = useQuery(
    [values.useQueryKeys.getAllProvince, selectedProvince],
    () =>
      api.getMethod.common.findProvinceCity({
        provinceId: selectedProvince?._id,
      })
  );

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <>
      <CustomIcon icon="fa fa-add" onClick={() => setShowModal!("CREATE")} />
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "CREATE"}
        minWidth={"35rem"}
        maxWidth={"40rem"}
        maxHeight={"75vh"}
      >
        <form onSubmit={submitHandler}>
          <CustomView.Container className="update-form-content">
            <TitleLine title="اطلاعات مسئول شرکت" />
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="firstName"
                  id="firstName"
                  label="نام"
                  value={formik.values.firstName}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.firstName && formik.touched.firstName}
                  errorText={formik.errors.firstName}
                />
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="lastName"
                  id="lastName"
                  label="نام خانوادگی"
                  value={formik.values.lastName}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.lastName && formik.touched.lastName}
                  errorText={formik.errors.lastName}
                />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum dropdown">
                <CustomInput
                  id="phoneNumber"
                  name="phoneNumber"
                  label="شماره موبایل"
                  value={formik.values.phoneNumber}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={
                    formik.errors.phoneNumber && formik.touched.phoneNumber
                  }
                  errorText={formik.errors.phoneNumber}
                  maxLength={11}
                />
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <div className="enter-number-container">
                  <CustomInput
                    name="userName"
                    id="userName"
                    value={formik.values.userName}
                    onValueChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    label="نام کاربری"
                    placeHolder="نام کاربری"
                    textAlign="center"
                    error={formik.errors.userName && formik.touched.userName}
                    errorText={formik.errors.userName}
                  />
                </div>
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <div className="enter-number-container">
                  <CustomInput
                    type="password"
                    name="password"
                    id="password"
                    value={formik.values.password}
                    onValueChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    label="گذرواژه"
                    placeHolder="گذرواژه"
                    textAlign="center"
                    error={formik.errors.password && formik.touched.password}
                    errorText={formik.errors.password}
                    isPassword
                  />
                </div>
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <div className="enter-number-container">
                  <CustomInput
                    type="password"
                    name="rePassword"
                    id="rePassword"
                    value={formik.values.rePassword}
                    onValueChange={(event) => {
                      formik.values.password === event.target.value
                        ? setErrors({ rePassword: "" })
                        : setErrors({
                            rePassword: "تکرار گذرواژه اشتباه است",
                          });
                      formik.handleChange(event);
                    }}
                    onBlur={formik.handleBlur}
                    label="تکرار گذرواژه"
                    placeHolder="تکرار گذرواژه"
                    textAlign="center"
                    isPassword
                  />
                </div>
                <div className="error">
                  {errors.rePassword !== "" && errors.rePassword}
                </div>
              </CustomView.Column>
            </CustomView.Row>
            <TitleLine title="اطلاعات شرکت" />
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <CustomDropDownSearch
                  itemName="name"
                  items={municipalities?.data?.result}
                  placeHolder="انتخاب شهرداری"
                  onSelectItem={(event) => setSelectedMunicipality(event)}
                  label="شهرداری"
                  defaultItem={selectedMunicipality}
                />
              </CustomView.Column>{" "}
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="name"
                  id="name"
                  label="نام شرکت"
                  value={formik.values.name}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.name && formik.touched.name}
                  errorText={formik.errors.name}
                />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row  row-align-start">
              <CustomView.Column medium={6}>
                <CustomDropDownSearch
                  items={getAllProvince?.data?.result}
                  itemName="title"
                  onSelectItem={(event) => {
                    setSelectedProvince(event);
                    setSelectedCity(undefined);
                  }}
                  placeHolder="انتخاب استان"
                  label="استان"
                  defaultItem={selectedProvince}
                  isSearch
                />
              </CustomView.Column>
              <CustomView.Column medium={6}>
                <CustomDropDownSearch
                  items={getAllCity?.data?.result}
                  itemName="title"
                  onSelectItem={(event) => setSelectedCity(event)}
                  placeHolder="انتخاب شهر"
                  label="شهر"
                  defaultItem={selectedCity}
                  isSearch
                />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row  row-align-start work-time-row">
              {/* <CustomView.Column medium={6} className="form-colum">
                <CustomView.Row className="form-row">
                  <CustomView.Column medium={12} className="form-colum">
                    <CustomDropDownSearch
                      itemName="name"
                      items={[]}
                      placeHolder="انتخاب شهر"
                      onSelectItem={() => ""}
                      label="شهر"
                    />
                  </CustomView.Column>
                  <CustomView.Column medium={12} className="form-colum">
                    <div className="city-items">
                      {selectedCities?.map((item) => (
                        <span>
                          {item?.name}{" "}
                          <i
                            onClick={() => {
                              setSelectedCities(
                                selectedCities?.filter(
                                  (filterItem) => filterItem._id !== item._id
                                )
                              );
                            }}
                            className="fa-solid fa-xmark close-mark"
                          ></i>
                        </span>
                      ))}
                    </div>
                  </CustomView.Column>
                </CustomView.Row>
              </CustomView.Column> */}
              <CustomView.Column medium={6} className="form-colum">
                <CustomView.Row className="form-row">
                  <CustomView.Column medium={12} className="form-colum">
                    <CustomDropDownSearch
                      itemName="completeName"
                      items={workTimesWithCompleteTitle}
                      placeHolder="انتخاب ساعت کاری"
                      onSelectItem={(event) =>
                        setSelectedWorkTimes([
                          ...(selectedWorkTimes as ICreateAndUpdateWorkTime[]),
                          event,
                        ])
                      }
                      label="ساعت کاری"
                    />
                  </CustomView.Column>
                  <CustomView.Column medium={12} className="form-colum">
                    <div className="city-items">
                      {selectedWorkTimes?.map((item) => (
                        <span>
                          {item?.completeName}{" "}
                          <i
                            onClick={() => {
                              setSelectedWorkTimes(
                                selectedWorkTimes?.filter(
                                  (filterItem) => filterItem._id !== item._id
                                )
                              );
                            }}
                            className="fa-solid fa-xmark close-mark"
                          ></i>
                        </span>
                      ))}
                    </div>
                  </CustomView.Column>
                </CustomView.Row>
              </CustomView.Column>
            </CustomView.Row>{" "}
            <CustomView.Row className="form-row">
              <CustomView.Column medium={2} className="form-colum">
                <ImageUploader
                  label="آپلود لوگو شرکت"
                  defaultImage={selectedImage}
                  setImage={setSelectedImage}
                  uploadImage={(event: any) => onUploadImage(event)}
                />{" "}
              </CustomView.Column>
              <CustomView.Column medium={12} className="form-colum">
                <CustomInput
                  name="address"
                  id="address"
                  label="آدرس"
                  value={formik.values.address}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.address && formik.touched.address}
                  errorText={formik.errors.address}
                />
              </CustomView.Column>
              <CustomView.Column medium={12}>
                <CustomLeafLet
                  defaultLat={selectedLocation?.lat}
                  defaultLng={selectedLocation?.lng}
                  defaultLatArea={selectedLocation?.lat}
                  defaultLngArea={selectedLocation?.lng}
                  onChangeLatAndLng={(lat, lng) =>
                    setSelectedLocation({ lat, lng })
                  }
                />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row buttons-row">
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={loading}
                  onClick={() => setShowModal!("NONE")}
                  title="لغو"
                  type="danger"
                />
              </CustomView.Column>
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={loading}
                  onClick={submitHandler}
                  title="ساخت شرکت"
                />
              </CustomView.Column>
            </CustomView.Row>
          </CustomView.Container>
        </form>
      </CustomModal>
    </>
  );
};

const gender: IItem[] = [
  { _id: "0", name: "مرد", value: "MALE" },
  { _id: "1", name: "زن", value: "FEMALE" },
];
const marital: IItem[] = [
  { name: "مجرد", value: "SINGLE" },
  { name: "متاهل", value: "MARRIED" },
];

export default CompanyDriverInformation;
